import React from 'react';
import { useRecordContext } from 'react-admin';
import { cms1500JobsFields } from "../../cms1500Jobs.model";
import EmptyField from "@/material/emptyField.component";

const HealthieCms1500LinkField = ({ source, addLabel = true }) => {
    const record = useRecordContext();

    if (!record || !source) {
        return null;
    }

    const value = record[source];
    if (!value) {
        return <EmptyField />;
    }

    // Get Healthie base URL from environment variable
    const healthieBaseUrl = import.meta.env.VITE_HEALTHIE_DASHBOARD_URL || 'https://secure.pacify.com';
    const healthieCms1500Url = `${healthieBaseUrl}/cms1500s/${value}/edit`;

    return (
        <a 
            href={healthieCms1500Url} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none' }}
        >
            {value}
        </a>
    );
};

export default HealthieCms1500LinkField;
